import { lazy } from "react";
import Loadable from "app/components/Loadable";

const LeadListPage = Loadable(lazy(() => import("./leads/LeadListPage")));
const LeadDetailPage = Loadable(lazy(() => import("./leads/LeadDetailPage")));

const CrmRoutes = [
  { path: "/crm/leads", element: <LeadListPage /> },
  { path: "/crm/leads/:leadId", element: <LeadDetailPage /> },
];

export default CrmRoutes;
